<div class="chart-row">
    <div class="chart-container business-volume">
        <div class="header">
            <h3>
                Aufgaben
            </h3>
            <button mat-icon-button (click)="taskFilter?.Toggle()" [matBadge]="taskFilterCount$ | async" matBadgeOverlap class="mat-badge-more-overlay" matBadgeSize="small" matTooltip="Filter" aria-label="Filter" >
                <fa-icon icon="filter"></fa-icon>
            </button>
        </div>
    <app-filter-card style="position: absolute; z-index: 2" [Inline]="true" UnlimitedHeight #taskFilter *ngIf="taskFilterSettings$ | async as settings" [Settings]="settings" [Values]="taskFilterValues$ | async" (ValuesChange)="setTaskFilter($event)"></app-filter-card>
        <app-doughnut-chart-wrapper
            #taskChart
            *ngIf="TaskDataSets$ | async as datasets; else noTasks"
            [HideLegend]="Mobile$ | async"
            [Options]="TaskChartOptions"
            [CenterTemplate]="centerTaskTemplate"
            [Datasets]="datasets"
            [Labels]="TaskLabels"
        ></app-doughnut-chart-wrapper>
        <ng-container *ngIf="TasksByCommission$ | async as groups">
            <div class="commission-breakdown" *ngIf="groups.length > 0">
                <ng-container *ngIf="TasksByCommission$ | async as groups">
                    <div class="commission-breakdown" *ngIf="groups.length > 1 ">

                        <details class="commission-group commission-group--projects-wrapper">
                            <summary>
                <span class="commission-name">
                    <fa-icon icon="chevron-down" class="chevron"></fa-icon>
                    {{ (cls.getMultiple$("Commission") | async) }}
                </span>
                            </summary>
                            <details class="commission-group" *ngFor="let group of groups">
                                <summary>
                    <span class="commission-name" [matTooltip]="group.toolTip">
                        <fa-icon icon="chevron-down" class="chevron"></fa-icon>
                        {{ group.label }}
                        <span *ngIf="!group.isMain" style="font-size: 0.75rem; opacity: 0.6">
                            (Teil{{ (cls.getSingle$("Commission") | async).toLocaleLowerCase() }})
                        </span>
                    </span>
                                </summary>
                                <div class="commission-counts">
                                    <div><span class="dot" [style.background]="colors.blue"></span>{{ group.counts.new }} Offen</div>
                                    <div><span class="dot" [style.background]="colors.orange"></span>{{ group.counts.inProgress }} In Bearbeitung</div>
                                    <div><span class="dot" [style.background]="colors.green"></span>{{ group.counts.done }} Erledigt</div>
                                    <div><span class="dot" [style.background]="colors.red"></span>{{ group.counts.overdue }} Überfällig</div>
                                </div>
                            </details>
                        </details>
                    </div>
                </ng-container>

            </div>
        </ng-container>

        <ng-template #centerTaskTemplate>
            <div style="transition: transform 0.2s; font-size: 2rem">
                <fa-icon style="cursor: pointer" [icon]="TaskIcon" size="lg" (click)="OnTaskIconClick($event)"></fa-icon>
            </div>
        </ng-template>

        <ng-template #noTasks>
            <ng-container *ngTemplateOutlet="noContent; context: { text: 'Keine Aufgaben vorhanden' }"> </ng-container>
        </ng-template>
    </div>

    <div class="chart-container business-volume" *ngIf="canGetBV$ | async">
        <div class="header">
            <h3>
                Umsätze (Netto)
            </h3>
            <app-hint-icon class="bv-tooltip" hint="Die Personaleinnahmen berechnen sich mittels: Std. x VK-Preis (siehe Jobbezeichnung).
Diese sind daher nur für das Controlling zu betrachten und stellen keine Ist-Umsätze dar. Diese Personaleinnahmen werden in Abhängigkeit der geplanten Einnahmen im inneren Kreis summiert für alle Projekte angezeigt."></app-hint-icon>
            <button mat-icon-button (click)="bvFilter?.Toggle()" [matBadge]="bvFilterCount$ | async" matBadgeOverlap class="mat-badge-more-overlay bv-filter-button" matBadgeSize="small" matTooltip="Filter" aria-label="Filter">
                <fa-icon icon="filter"></fa-icon>
            </button>


        </div>
        <app-filter-card UnlimitedHeight #bvFilter *ngIf="bvFilterSettings$ | async as settings" [Settings]="settings" [Values]="bvFilterValues$ | async" (ValuesChange)="setBvFilter($event)"></app-filter-card>
        <app-doughnut-chart-wrapper
            #bvChart
            *ngIf="BusinessVolumeDataSets$ | async as datasets; else noBV"
            [HideLegend]="Mobile$ | async"
            [Subline]="(Commission$ | async)?.CompleteBusinessVolume ? 'geplant: ' + ((Commission$ | async)?.CompleteBusinessVolume / 100 | number: '1.2-2') + ' €' : ''"
            [Options]="BusinessVolumeChartOptions$ | async"
            [CenterTemplate]="centerBVTemplate"
            [Datasets]="datasets"
            [Labels]="BusinessVolumeLabels$ | async"
        ></app-doughnut-chart-wrapper>
        <ng-container *ngIf="TimesByCommission$ | async as groups">
        <div class="commission-breakdown" *ngIf="groups.length > 0">


            <ng-container *ngIf="groups.length === 1">
                <details class="commission-group" *ngFor="let group of groups">
                    <summary>
          <span class="commission-name" [matTooltip]="group.toolTip">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
            <span class="dot" [style.background]="group.color"></span>
              {{ group.label }}
          </span>
                    </summary>
                    <div class="commission-counts">
                        <div *ngFor="let type of group.types">
                            <span class="dot" [style.background]="group.color"></span>
                            {{ type.sellPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} {{ type.label }}
                        </div>
                    </div>
                </details>
            </ng-container>
            <ng-container *ngIf="groups.length > 1">
                <details class="commission-group commission-group--projects-wrapper">
                    <summary>
          <span class="commission-name">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              {{ (cls.getMultiple$("Commission") | async) }}
          </span>
                    </summary>

                    <details class="commission-group commission-group--project" *ngFor="let group of groups">
                        <summary>
            <span class="commission-name" [matTooltip]="group.toolTip">
              <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              <span class="dot" [style.background]="group.color"></span>
                {{ group.label }}
                <span *ngIf="!group.isMain" style="font-size: 0.75rem; opacity: 0.6">
                (Teil{{ (cls.getSingle$("Commission") | async).toLocaleLowerCase() }})
              </span>
            </span>
                        </summary>
                        <div class="commission-counts">
                            <div *ngFor="let type of group.types">
                                <span class="dot" [style.background]="group.color"></span>
                                {{ type.sellPrice | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} {{ type.label }}
                            </div>
                        </div>
                    </details>

                </details>
            </ng-container>
        </div>
    </ng-container>
        <ng-template #centerBVTemplate>
            <div style="text-align: center; display: flex; flex-direction: column">
                <button  mat-icon-button (click)="$event.stopPropagation(); openBVPopup(null, BusinessVolumeCostStateEnum.Income)" style="width: 30px;height: 30px;margin: -10px auto 0;" matTooltip="Listenansicht" aria-label="Listenansicht">
                    <fa-icon icon="list"></fa-icon>
                </button>
                <span>Umsatz bisher:</span>
                <span style="font-size: larger; font-weight: bold">{{ BusinessVolumeSum$ | async | number: '1.2-2' }} €</span>
            </div>
        </ng-template>
        <ng-template #noBV>
            <ng-container *ngTemplateOutlet="noContent; context: { text: 'Keine Umsätze vorhanden' }"> </ng-container>
        </ng-template>
    </div>

    <div class="chart-container business-volume" *ngIf="canGetBV$ | async">
        <div class="header">
            <h3>
                Kosten (Netto)
            </h3>
            <app-hint-icon class="bv-tooltip" hint="Die Personalkosten berechnen sich mittels: Std. x Kosten (siehe Jobbezeichnung).
Diese sind daher nur für das Controlling zu betrachten und stellen keine Ist-Kosten dar."></app-hint-icon>
            <button  mat-icon-button (click)="costFilter?.Toggle()" [matBadge]="bvCostFilterCount$ | async" matBadgeOverlap class="mat-badge-more-overlay bv-filter-button" matBadgeSize="small" matTooltip="Filter" aria-label="Filter">
                <fa-icon icon="filter"></fa-icon>
            </button>

        </div>
        <app-filter-card UnlimitedHeight #costFilter *ngIf="bvCostFilterSettings$ | async as settings" [Settings]="settings" [Values]="bvCostFilterValues$ | async" (ValuesChange)="setBvCostFilter($event)"></app-filter-card>
        <app-doughnut-chart-wrapper
            #bvCostChart
            *ngIf="BusinessVolumeCostDataSets$ | async as datasets; else noBVC"
            [HideLegend]="Mobile$ | async"
            [Subline]="(Commission$ | async)?.CostsCompleteBusinessVolume ? 'geplant: ' + ((Commission$ | async)?.CostsCompleteBusinessVolume / 100 | number: '1.2-2') + ' €' : ''"
            [Options]="BusinessVolumeCostChartOptions$ | async"
            [CenterTemplate]="centerBVCostTemplate"
            [Datasets]="datasets"
            [Labels]="BusinessVolumeCostsLabels$ | async"
        ></app-doughnut-chart-wrapper>
        <ng-container *ngIf="TimesByCommissionCostsFilter$ | async as groups">
            <div class="commission-breakdown" *ngIf="groups.length > 0">
                <ng-container *ngIf="groups.length === 1">
                    <details class="commission-group" *ngFor="let group of groups">
                        <summary>
          <span class="commission-name" [matTooltip]="group.toolTip">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
            <span class="dot" [style.background]="group.color"></span>
              {{ group.label }}
          </span>
                        </summary>
                        <div class="commission-counts">
                            <div *ngFor="let type of group.types">
                                <span class="dot" [style.background]="group.color"></span>
                                {{ type.cost | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} {{ type.labelCost }}
                            </div>
                        </div>
                    </details>
                </ng-container>
                <ng-container *ngIf="groups.length > 1">
                    <details class="commission-group commission-group--projects-wrapper">
                        <summary>
          <span class="commission-name">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              {{ (cls.getMultiple$("Commission") | async) }}
          </span>
                        </summary>

                        <details class="commission-group commission-group--project" *ngFor="let group of groups">
                            <summary>
            <span class="commission-name" [matTooltip]="group.toolTip">
              <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              <span class="dot" [style.background]="group.color"></span>
                {{ group.label }}
                <span *ngIf="!group.isMain" style="font-size: 0.75rem; opacity: 0.6">
                (Teil{{ (cls.getSingle$("Commission") | async).toLocaleLowerCase() }})
              </span>
            </span>
                            </summary>
                            <div class="commission-counts">
                                <div *ngFor="let type of group.types">
                                    <span class="dot" [style.background]="group.color"></span>
                                    {{ type.cost | currency: 'EUR' : 'symbol' : '1.2-2' : 'de-DE' }} {{ type.labelCost }}
                                </div>
                            </div>
                        </details>

                    </details>
                </ng-container>
            </div>
        </ng-container>
        <ng-template #centerBVCostTemplate>
            <div style="text-align: center; display: flex; flex-direction: column">
                <button mat-icon-button (click)="$event.stopPropagation(); openBVPopup(null, BusinessVolumeCostStateEnum.Costs)" style="width: 30px;height: 30px;margin: -10px auto 0;" matTooltip="Listenansicht" aria-label="Listenansicht">
                    <fa-icon icon="list"></fa-icon>
                </button>
                <span>Bezahlt bisher:</span>
                <span style="font-size: larger; font-weight: bold">{{ BusinessVolumeCostSum$ | async | number: '1.2-2' }} €</span>
            </div>
        </ng-template>
        <ng-template #noBVC>
            <ng-container *ngTemplateOutlet="noContent; context: { text: 'Keine Kosten vorhanden' }"> </ng-container>
        </ng-template>
    </div>

    <div class="chart-container business-volume">
        <div class="header">
            <h3>
                Zeiten
            </h3>
<!--            <button mat-icon-button  matBadgeOverlap class="mat-badge-more-overlay" matBadgeSize="small" matTooltip="Listenansicht" aria-label="Listenansicht" (click)="OpenUser2CommissionList()">-->
<!--                <fa-icon icon="list"></fa-icon>-->
<!--            </button>-->

            <button mat-icon-button (click)="timeFilter?.Toggle()" [matBadge]="timeFilterCount$ | async" matBadgeOverlap class="mat-badge-more-overlay" matBadgeSize="small" matTooltip="Filter" aria-label="Filter">
                <fa-icon icon="filter"></fa-icon>
            </button>
        </div>
        <app-filter-card UnlimitedHeight #timeFilter *ngIf="timeFilterSettings$ | async as settings" [Settings]="settings" [Values]="timeFilterValues$ | async" (ValuesChange)="setTimeFilter($event)"></app-filter-card>
        <app-doughnut-chart-wrapper
            #timeChart
            *ngIf="TimeDataSets$ | async as datasets; else noTime"
            [HideLegend]="Mobile$ | async"
            [Subline]="(TargetTime$ | async) ? 'geplant: ' + ((TargetTime$ | async) / 1000 / 60 / 60 | number: '1.2-2') + ' Std.' : ''"
            [Options]="TimeChartOptions"
            [CenterTemplate]="centerTimeTemplate"
            [Datasets]="datasets"
            [Labels]="TimeLabels$ | async"
        ></app-doughnut-chart-wrapper>
        <ng-container *ngIf="TimesByCommissionHours$ | async as groups">
            <div class="commission-breakdown" *ngIf="groups.length > 0">

                <!-- Nur 1 Auftrag: direkt anzeigen, kein Wrapper -->
                <ng-container *ngIf="groups.length === 1">
                    <details class="commission-group" *ngFor="let group of groups">
                        <summary>
          <span class="commission-name" [matTooltip]="group.toolTip">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
            <span class="dot" [style.background]="group.color"></span>
              {{ group.label }}
          </span>
                        </summary>
                        <div class="commission-counts">
                            <div *ngFor="let type of group.types">
                                <span class="dot" [style.background]="group.isMain ? type.color : group.color"></span>
                                {{ type.hours | number:'1.2-2':'de-DE' }} Std. {{ type.label }}
                            </div>
                        </div>
                    </details>
                </ng-container>

                <!-- Mehrere Aufträge: alle in einem "Projekte"-Wrapper -->
                <ng-container *ngIf="groups.length > 1">
                    <details class="commission-group commission-group--projects-wrapper">
                        <summary>
          <span class="commission-name" [matTooltip]="groups[0].toolTip">
            <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              {{ (cls.getMultiple$("Commission") | async) }}
          </span>
                        </summary>

                        <details class="commission-group commission-group--project" *ngFor="let group of groups">
                            <summary>
            <span class="commission-name" [matTooltip]="group.toolTip">
              <fa-icon icon="chevron-down" class="chevron"></fa-icon>
              <span class="dot" [style.background]="group.color"></span>
                {{ group.label }}
                <span *ngIf="!group.isMain" style="font-size: 0.75rem; opacity: 0.6">
                (Teil{{ (cls.getSingle$("Commission") | async).toLocaleLowerCase() }})
              </span>
            </span>
                            </summary>
                                <div class="commission-counts">
                                    <div *ngFor="let type of group.types">
                                        <span class="dot" [style.background]="group.isMain ? type.color : group.color"></span>
                                        {{ type.hours | number:'1.2-2':'de-DE' }} Std. {{ type.label }}
                                    </div>
                                </div>
                        </details>

                    </details>
                </ng-container>

            </div>
        </ng-container>
        <ng-template #centerTimeTemplate>
            <div style="text-align: center; display: flex; flex-direction: column">
                <button mat-icon-button style="width: 30px;height: 30px;margin: -10px auto 0;" matTooltip="Listenansicht" aria-label="Listenansicht" (click)="$event.stopPropagation(); OpenUser2CommissionList()">
                    <fa-icon icon="list"></fa-icon>
                </button>
                <span>Stunden bisher:</span>
                <span style="font-size: larger; font-weight: bold">{{ (TimeSum$ | async) / 1000 / 60 / 60 | number: '1.2-2' }} Std.</span>
            </div>
        </ng-template>
        <ng-template #noTime>
            <ng-container *ngTemplateOutlet="noContent; context: { text: 'Keine Zeiten vorhanden' }"> </ng-container>
        </ng-template>
    </div>
    <app-commission-scheduler [commissionId]="CommissionId$ | async"></app-commission-scheduler>
</div>
<ng-container *ngTemplateOutlet="timelineTemplate"></ng-container>
<ng-template #noContent let-text="text">
    <p class="no-content">{{ text }}</p>
</ng-template>

<ng-template #loading>
    <app-loading></app-loading>
</ng-template>


<ng-template #timelineTemplate>
    <!--        <div class="pointer-wrapper">-->
    <!--            <span class="pointer" *ngFor="let conf of timelineConfig.pointer" [style.left]="conf.state">{{conf.label}}</span>-->
    <!--        </div>-->
    <!-- Meilensteine / Milestone-->
    <ng-container *ngIf="GetMileStonePermission">
        <hr />
        <h3>Projektverlauf</h3>
        <button *ngIf="(CreateMileStonePermission)" class="milestone-button" app-round-button matTooltip="Meilenstein erstellen" matTooltipPosition="left" (click)="MilestoneClicked()">
            <app-double-icon Icon="flag" Icon2="plus"></app-double-icon>
        </button>

        <app-progress-timeline class="timeline-wrapper" (EventClick)="MilestoneClicked($event)" [From]="timelineConfig.start" [To]="timelineConfig.end" [State]="timelineConfig.fillDate" [Events]="timelineConfig.pointer$ | async" *ngIf="TimelineFillWidth$ | async as timelineConfig" ></app-progress-timeline>
    </ng-container>
</ng-template>
<ng-template #listCardDialogFooter>
    <button (click)="BVListDialogRef.close()" app-button>Schließen</button>
</ng-template>
